import React from 'react';
import { Box, Button, Paper, TextField } from '@mui/material';
import { Notification } from './Notification';
import { Notification as INotification } from '../model';
import { createNotificationRequest, useGetnotifications } from '../api';
import { Table } from 'src/components/common/Table';
import { format } from 'date-fns';

interface Props {
  userId?: number | string;
}

export const NotificationsList: React.FunctionComponent<Props> = ({
  userId,
}) => {
  const [message, setMessage] = React.useState({ title: '', body: '' });

  const notificationsRequest = useGetnotifications({
    variables: {
      userId,
      limit: 20,
      offset: 0,
    },
    skip: !userId,
  });

  const sendNotification = () => {
    if (!userId || !message.title || !message.body) return;
    createNotificationRequest({
      body: message.body,
      title: message.title,
      userIds: [Number(userId)],
    }).then(() => {
      notificationsRequest.mutate();
      setMessage({ title: '', body: '' });
    });
  };
  return (
    <Box>
      <Paper>
        <Table
          loading={notificationsRequest.isLoading}
          data={notificationsRequest.data?.data?.messages || []}
          totalCount={notificationsRequest.data?.totalCount || 0}
          title="Уведомления"
          headers={[
            {
              title: 'id',
              component: 'th',
              scope: 'row',
              align: 'right',
              extract: (item: INotification) => item.id,
            },
            {
              title: 'Дата',
              extract: (item: INotification) =>
                format(new Date(item.createdAt), 'yyyy-MM-dd HH:mm:ss'),
            },
            {
              title: 'Заголовок',
              extract: (item: INotification) => item.title,
            },
            {
              title: 'Сообщение',
              extract: (item: INotification) => item.body,
            },
            {
              title: 'Сайт',
              extract: (item: INotification) => (
                <Box>
                  {item?.deliveries?.website?.deliveredAt && (
                    <Box title="Доставлено">
                      ✉️
                      {format(
                        new Date(
                          item?.deliveries?.website?.deliveredAt as string,
                        ),
                        'yyyy-MM-dd HH:mm:ss',
                      )}
                    </Box>
                  )}
                  {item?.deliveries?.website?.readAt && (
                    <Box title="Прочитано">
                      ✅
                      {format(
                        new Date(item?.deliveries?.website?.readAt as string),
                        'yyyy-MM-dd HH:mm:ss',
                      )}
                    </Box>
                  )}
                </Box>
              ),
            },
            {
              title: 'Телеграм',
              extract: (item: INotification) => (
                <Box maxWidth="300px">
                  {item?.deliveries?.telegram?.deliveredAt && (
                    <Box title="Доставлено">
                      ✉️
                      {format(
                        new Date(
                          item?.deliveries?.telegram?.deliveredAt as string,
                        ),
                        'yyyy-MM-dd HH:mm:ss',
                      )}
                    </Box>
                  )}
                  {item?.deliveries?.telegram?.readAt && (
                    <Box title="Прочитано">
                      ✅
                      {format(
                        new Date(item?.deliveries?.telegram?.readAt as string),
                        'yyyy-MM-dd HH:mm:ss',
                      )}
                    </Box>
                  )}
                  {item?.deliveries?.telegram?.error && (
                    <Box title="Ошибка">
                      ❌{item?.deliveries?.telegram?.error}
                    </Box>
                  )}
                </Box>
              ),
            },
          ]}
        />
      </Paper>
      <Box mt={2}>
        <Paper>
          <Box p={2}>
            <Box>
              <TextField
                label="Заголовок уведомления"
                fullWidth
                value={message.title}
                onChange={e =>
                  setMessage({ ...message, title: e.target.value })
                }
              />
            </Box>
            <Box mt={2}>
              <TextField
                label="Текст уведомления"
                fullWidth
                value={message.body}
                onChange={e => setMessage({ ...message, body: e.target.value })}
              />
            </Box>
            <Box mt={2}>
              <Button
                variant="contained"
                disabled={!message.title || !message.body}
                onClick={sendNotification}
              >
                Отправить
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
